document.addEventListener('DOMContentLoaded',()=>{

  const items = document.querySelectorAll('.asia24-faq-item');

  items.forEach(item=>{

    const question =
      item.querySelector('.asia24-faq-question');

    const answer =
      item.querySelector('.asia24-faq-answer');

    question.addEventListener('click',()=>{

      const active =
        item.classList.contains('active');

      items.forEach(i=>{

        i.classList.remove('active');

        i.querySelector('.asia24-faq-answer')
          .style.maxHeight = null;

      });

      if(!active){

        item.classList.add('active');

        answer.style.maxHeight =
          answer.scrollHeight + 'px';

      }

    });

  });

});